<template>
  <el-dialog
    title="编辑特定规则"
    :visible.sync="dialogVisible"
    fullscreen          
    :close-on-click-modal="false"
    @close="closeDialog"
    v-loading="tierLoading"
    element-loading-text="加载中..."
  >
    <div class="tier-dialog">
      <!-- 匹配规则说明 -->
      <el-alert
        title="匹配规则说明"
        type="info"
        :closable="false"
        style="margin-bottom: 15px;"
      >
        <div style="line-height: 1.8;">
          <p style="margin: 0 0 8px 0;"><strong>订单提成时的匹配优先级：</strong></p>
          <p style="margin: 0 0 5px 0;">
            <strong>1. 精确度优先：</strong>匹配条件越多越优先（公司+品牌+车型+省+市+区 共6个条件，条件越完整优先级越高）
          </p>
          <p style="margin: 0 0 5px 0;">
            <strong>2. 业务属性优先：</strong>当匹配条件数相同时，<span style="color: #E6A23C; font-weight: bold;">品牌车型规则优先于地区规则</span>
          </p>
          <p style="margin: 0 0 5px 0;">
            <strong>举例：</strong>订单为"上海挚达+比亚迪+海洋+浙江省+丽水市+青田县"
          </p>
          <ul style="margin: 5px 0 0 20px; padding: 0;">
            <li>规则A：上海挚达+比亚迪+海洋（3个条件，3个业务属性）</li>
            <li>规则B：上海挚达+浙江省+丽水市（3个条件，1个业务属性）</li>
            <li style="color: #67C23A; font-weight: bold;">✓ 匹配结果：优先使用规则A（业务属性更多）</li>
          </ul>
        </div>
      </el-alert>
      
      <div class="tier-table">
        <div class="table-add">
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            v-show="authorization('/home-admin/commission-rule/rule/tier-add')"
            @click="editTierItem(false)"
          >
            新增
          </el-button>
        </div>
        <el-table
          :data="tierTableData"
          stripe
          size="small"
          :header-cell-style="{
            'background-color': '#84aace4a',
            color: '#343333',
            'text-align': 'center',
          }"
          :cell-style="{ 'text-align': 'center' }"
          max-height="calc(100vh - 250px)"
        >
          <el-table-column prop="companyName" label="公司" show-overflow-tooltip></el-table-column>
          <el-table-column prop="brandName" label="品牌" show-overflow-tooltip></el-table-column>
          <el-table-column prop="modelName" label="车型" show-overflow-tooltip></el-table-column>
          <el-table-column prop="province" label="省" show-overflow-tooltip></el-table-column>
          <el-table-column prop="city" label="市" show-overflow-tooltip></el-table-column>
          <el-table-column prop="district" label="区" show-overflow-tooltip></el-table-column>
          <el-table-column prop="commissionRate" label="提成比例">
            <template slot-scope="scope">
              <span>{{ scope.row.commissionRate }}%</span>
            </template>
          </el-table-column>
          <el-table-column prop="remarks" label="备注" show-overflow-tooltip></el-table-column>
          <el-table-column prop="createdByStr" label="创建人"></el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="160">
            <template slot-scope="scope">
              <span>{{ formatDateTime(scope.row.createTime) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="updatedByStr" label="修改人"></el-table-column>
          <el-table-column prop="updateTime" label="修改时间" width="160">
            <template slot-scope="scope">
              <span>{{ formatDateTime(scope.row.updateTime) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="150">
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                content="编辑"
                placement="top-end"
                v-show="authorization('/home-admin/commission-rule/rule/tier-edit-item')"
              >
                <el-button
                  type="primary"
                  icon="el-icon-edit"
                  circle
                  size="mini"
                  style="margin-right: 5px"
                  @click="editTierItem(scope.row)"
                ></el-button>
              </el-tooltip>
              <el-tooltip
                effect="dark"
                content="删除"
                placement="top-end"
                v-show="authorization('/home-admin/commission-rule/rule/tier-delete')"
              >
                <el-popconfirm
                  title="确认删除吗？"
                  @confirm="deleteTierItem(scope.row)"
                >
                  <el-button
                    slot="reference"
                    type="danger"
                    icon="el-icon-delete"
                    circle
                    size="mini"
                  ></el-button>
                </el-popconfirm>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 特定规则新增/修改Dialog -->
    <el-dialog
      :title="currentTier ? '编辑特定规则' : '新增特定规则'"
      :visible.sync="tierItemDialogVisible"
      width="900px"
      :close-on-click-modal="false"
      append-to-body
      @close="closeTierItemDialog"
      v-loading="submitLoading"
      element-loading-text="提交中..."
    >
      <!-- 提示说明 -->
      <el-alert
        type="warning"
        :closable="false"
        style="margin-bottom: 15px;"
      >
        <div style="line-height: 1.6; font-size: 13px;">
          <strong>温馨提示：</strong>
          <p style="margin: 5px 0 0 0;">• 填写的条件越完整，该规则匹配优先级越高</p>
          <p style="margin: 3px 0 0 0;">• 当条件数相同时，业务属性（公司/品牌/车型）优先于地区属性（省/市/区）</p>
          <p style="margin: 3px 0 0 0;">• 至少需要选择公司，其他字段可选填</p>
        </div>
      </el-alert>
      
      <el-form
        :model="tierForm"
        :rules="tierRules"
        ref="tierFormRef"
        label-width="160px"
        size="small"
        style="width: 800px"
      >
        <el-form-item label="公司:" prop="companyId">
          <el-select
            v-model="tierForm.companyId"
            placeholder="请选择公司"
            style="width: 100%"
            filterable
            @change="handleCompanyChange"
          >
            <el-option
              v-for="item in companyDrownList"
              :key="item.companyId"
              :label="item.companyManager"
              :value="item.companyId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="品牌:" prop="brandId">
          <el-select
            v-model="tierForm.brandId"
            placeholder="请选择品牌"
            style="width: 100%"
            filterable
            clearable
            @change="handleBrandChange"
          >
            <el-option
              v-for="item in deviceBrandDrownList"
              :key="item.id"
              :label="item.brandName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="车型:" prop="modelId">
          <el-select
            v-model="tierForm.modelId"
            placeholder="请选择车型"
            style="width: 100%"
            filterable
            clearable
            :disabled="!tierForm.brandId"
          >
            <el-option
              v-for="item in filteredModelList"
              :key="item.id"
              :label="item.modelName + ' | ' + item.brandName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="省市区:" prop="regionPath">
          <el-cascader
            style="width: 100%"
            :options="options"
            :props="{ value: 'label', children: 'children', checkStrictly: true }"
            v-model="tierForm.regionPath"
            clearable
            @change="handleRegionChange"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="提成百分比:" prop="commissionRate">
          <el-input
            v-model="tierForm.commissionRate"
            placeholder="请输入提成百分比，如1.00表示1%"
            style="width: 100%"
          >
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
        <el-form-item label="备注:" prop="remarks">
          <el-input
            type="textarea"
            placeholder="请输入备注（最多500字）"
            maxlength="500"
            v-model="tierForm.remarks"
            :rows="4"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeTierItemDialog" size="small" :disabled="submitLoading">取 消</el-button>
        <el-button type="primary" @click="submitTierItem" size="small" :loading="submitLoading">确 定</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { authorization } from "@/authorization/authorization";
import { regionData } from "element-china-area-data";
import moment from "moment";

export default {
  name: "TierDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    ruleId: {
      type: Number,
      required: true,
    },
  },
  data() {
    const validateCommissionRate = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入提成百分比"));
        return;
      }
      const num = parseFloat(value);
      if (isNaN(num) || num < 0) {
        callback(new Error("提成百分比必须大于等于0"));
        return;
      }
      // 检查是否为两位小数
      const decimalPart = value.toString().split(".")[1];
      if (decimalPart && decimalPart.length < 2) {
        callback(new Error("提成百分比最小两位小数"));
        return;
      }
      callback();
    };

    return {
      dialogVisible: this.visible,
      tierTableData: [],
      tierLoading: false,
      submitLoading: false,
      tierItemDialogVisible: false,
      currentTier: null,
      tierForm: {
        companyId: null,
        brandId: null,
        modelId: null,
        regionPath: [],
        commissionRate: null,
        remarks: "",
      },
      tierRules: {
        companyId: [{ required: true, message: "请选择公司", trigger: "change" }],
        commissionRate: [{ required: true, validator: validateCommissionRate, trigger: "blur" }],
      },
      companyDrownList: [],
      deviceBrandDrownList: [],
      allDeviceModelDrownList: [],
      options: regionData,
    };
  },
  computed: {
    filteredModelList() {
      if (!this.tierForm.brandId) {
        return [];
      }
      return this.allDeviceModelDrownList.filter(
        (item) => item.brandId === this.tierForm.brandId
      );
    },
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val) {
        // 弹窗打开时，先清空数据并设置loading，避免显示"无数据"
        this.tierTableData = [];
        this.tierLoading = true;
        // 使用nextTick确保loading状态已设置
        this.$nextTick(() => {
          this.getTierList();
          this.initData();
        });
      } else {
        // 弹窗关闭时，清空数据
        this.tierTableData = [];
        this.tierLoading = false;
      }
    },
    dialogVisible(val) {
      this.$emit("update:visible", val);
    },
  },
  created() {
    this.initData();
  },
  methods: {
    authorization,
    initData() {
      // 获取公司列表
      this.$store.dispatch("setCompany").then(() => {
        this.companyDrownList = this.$store.state.company;
      });
      // 获取品牌列表
      this.$store.dispatch("setBrand").then(() => {
        this.deviceBrandDrownList = this.$store.state.brand;
      });
      // 获取车型列表
      this.queryDeviceModelDrown();
    },
    queryDeviceModelDrown() {
      this.axios({
        method: "get",
        url: "/v1/web/device-brand/select-device-model",
      }).then((res) => {
        if (res.data.code === 200) {
          this.allDeviceModelDrownList = res.data.data?.list || res.data.data || [];
        }
      });
    },
    getTierList() {
      // 确保loading状态已设置
      if (!this.tierLoading) {
        this.tierLoading = true;
      }
      // 先清空数据，避免显示旧数据
      this.tierTableData = [];
      this.axios({
        url: `/v1/web/commission-rule/tier/list/${this.ruleId}`,
        method: "get",
      })
        .then((res) => {
          if (res.data.code === 200) {
            // 处理数据，添加名称字段
            const tierList = res.data.data || [];
            // 获取公司、品牌、车型列表用于填充名称
            this.tierTableData = tierList.map((item) => {
              // 查询公司名称
              const company = this.companyDrownList.find(
                (c) => c.companyId === item.companyId
              );
              // 查询品牌名称
              const brand = this.deviceBrandDrownList.find((b) => b.id === item.brandId);
              // 查询车型名称
              const model = this.allDeviceModelDrownList.find((m) => m.id === item.modelId);
              return {
                ...item,
                companyName: company ? company.companyManager : "",
                brandName: brand ? brand.brandName : "",
                modelName: model ? model.modelName : "",
                // 使用后端返回的createdByStr和updatedByStr（已通过UserUtil填充）
                createdByStr: item.createdByStr || "",
                updatedByStr: item.updatedByStr || "",
              };
            }).sort((a, b) => {
              // 排序规则：公司、品牌、车型、省、市、区
              // null值排在最后
              const compareValue = (valA, valB) => {
                if (!valA && !valB) return 0;
                if (!valA) return 1; // null排在后面
                if (!valB) return -1; // null排在后面
                return valA.localeCompare(valB, 'zh-CN');
              };

              // 1. 按公司排序
              let result = compareValue(a.companyName, b.companyName);
              if (result !== 0) return result;

              // 2. 按品牌排序
              result = compareValue(a.brandName, b.brandName);
              if (result !== 0) return result;

              // 3. 按车型排序
              result = compareValue(a.modelName, b.modelName);
              if (result !== 0) return result;

              // 4. 按省排序
              result = compareValue(a.province, b.province);
              if (result !== 0) return result;

              // 5. 按市排序
              result = compareValue(a.city, b.city);
              if (result !== 0) return result;

              // 6. 按区排序
              result = compareValue(a.district, b.district);
              return result;
            });
            // 数据设置完成后关闭loading
            this.tierLoading = false;
          } else {
            this.$message.error(res.data.message);
            this.tierLoading = false;
          }
        })
        .catch((error) => {
          this.$message.error("加载数据失败，请重试");
          console.error(error);
          this.tierLoading = false;
        });
    },
    editTierItem(data) {
      if (data) {
        // 编辑模式
        this.currentTier = { ...data };
        // 由于el-cascader配置了value: 'label'，regionPath数组需要存储名称
        // 后端存储的province、city、district就是名称，直接使用即可
        let regionPath = [];
        if (data.province || data.city || data.district) {
          regionPath = [
            data.province || null,
            data.city || null,
            data.district || null
          ].filter(item => item !== null); // 过滤掉null值
        }
        this.tierForm = {
          id: data.id,
          companyId: data.companyId,
          brandId: data.brandId,
          modelId: data.modelId,
          regionPath: regionPath,
          commissionRate: data.commissionRate,
          remarks: data.remarks || "",
        };
      } else {
        // 新增模式
        this.currentTier = null;
        this.tierForm = {
          companyId: null,
          brandId: null,
          modelId: null,
          regionPath: [],
          commissionRate: null,
          remarks: "",
        };
      }
      this.tierItemDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.tierFormRef) {
          this.$refs.tierFormRef.clearValidate();
        }
      });
    },
    handleCompanyChange() {
      // 公司改变时，可以清空品牌和车型
    },
    handleBrandChange() {
      // 品牌改变时，清空车型
      this.tierForm.modelId = null;
    },
    handleRegionChange(value) {
      // 省市区改变时的处理
      // 确保值被正确保存到 tierForm.regionPath
      console.log('省市区选择变化:', value);
      this.tierForm.regionPath = value || [];
    },
    submitTierItem() {
      this.$refs.tierFormRef.validate((valid) => {
        if (valid) {
          // 处理省市区数据：由于el-cascader配置了value: 'label'，regionPath数组存储的就是名称
          // 当checkStrictly为true时，数组长度可能是1、2或3
          let province = null;
          let city = null;
          let district = null;
          if (this.tierForm.regionPath && Array.isArray(this.tierForm.regionPath) && this.tierForm.regionPath.length > 0) {
            // regionPath数组中的值就是省市区名称，直接使用
            // 根据数组长度判断选择了哪些层级
            if (this.tierForm.regionPath.length >= 1) {
              province = this.tierForm.regionPath[0] || null;
            }
            if (this.tierForm.regionPath.length >= 2) {
              city = this.tierForm.regionPath[1] || null;
            }
            if (this.tierForm.regionPath.length >= 3) {
              district = this.tierForm.regionPath[2] || null;
            }
          }

          // 构建提交数据，确保省市区字段不被覆盖
          const data = {
            id: this.tierForm.id,
            ruleId: this.ruleId,
            companyId: this.tierForm.companyId,
            brandId: this.tierForm.brandId,
            modelId: this.tierForm.modelId,
            province: province,
            city: city,
            district: district,
            commissionRate: parseFloat(this.tierForm.commissionRate),
            remarks: this.tierForm.remarks || null,
          };

          // 调试：打印提交的数据
          console.log('提交的省市区数据:', { 
            province, 
            city, 
            district, 
            regionPath: this.tierForm.regionPath,
            fullData: data 
          });

          const url = this.currentTier
            ? "/v1/web/commission-rule/tier/update"
            : "/v1/web/commission-rule/tier/add";
          this.submitLoading = true;
          this.axios({
            url,
            method: "post",
            data,
          }).then((res) => {
            if (res.data.code === 200) {
              this.$message.success(this.currentTier ? "修改成功" : "新增成功");
              this.$emit("success");
              this.getTierList();
              this.closeTierItemDialog();
            } else {
              this.$message.error(res.data.message);
            }
          }).catch((error) => {
            this.$message.error("操作失败，请重试");
            console.error(error);
          }).finally(() => {
            this.submitLoading = false;
          });
        }
      });
    },
    deleteTierItem(data) {
      this.tierLoading = true;
      this.axios({
        url: `/v1/web/commission-rule/tier/delete/${data.id}`,
        method: "delete",
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message.success("删除成功");
          this.getTierList();
        } else {
          this.$message.error(res.data.message);
        }
      }).catch((error) => {
        this.$message.error("删除失败，请重试");
        console.error(error);
      }).finally(() => {
        this.tierLoading = false;
      });
    },
    closeTierItemDialog() {
      if (this.$refs.tierFormRef) {
        this.$refs.tierFormRef.resetFields();
      }
      this.tierForm = {
        companyId: null,
        brandId: null,
        modelId: null,
        regionPath: [],
        commissionRate: null,
        remarks: "",
      };
      this.currentTier = null;
      this.submitLoading = false;
      this.tierItemDialogVisible = false;
    },
    closeDialog() {
      this.tierTableData = [];
      this.tierLoading = false;
      this.dialogVisible = false;
    },
    formatDateTime(time) {
      if (!time) return "-";
      // 如果是时间戳（数字），转换为日期对象
      if (typeof time === "number") {
        return moment(time).format("YYYY-MM-DD HH:mm");
      }
      // 如果是字符串，直接格式化
      return moment(time).format("YYYY-MM-DD HH:mm");
    },
  },
};
</script>

<style scoped>
.tier-dialog {
  width: 100%;
}

.tier-table {
  width: 100%;
}

.table-add {
  margin-bottom: 10px;
}
</style>

